<template>
  <div class="nav-page-view">
    <div class="nav-title flex-middle-x layout-flex-justify-content_space-between">
      <div class="flex-middle-x">
        <img :src="appLogo" alt="">
        <h1>上海金保证网络科技有限公司</h1>
      </div>
      <img class="app-on-off" :src="appOnOff" alt="" @click="actionClickTab">
    </div>
    <ul :class="{ 'ulHover': isTab}" class="flex-middle-x layout-flex-justify-content_space-between">
      <li v-for="(item,index) in navTabList"
          :class="{ 'hover': index === tabHover}"
          @click="actionClickNavTab(item.id)">
        {{item.name}}
      </li>
    </ul>
  </div>
</template>
<script>
  export default {
    name:'',
    data(){
      return {
        isTab:false,
        tabHover:0,
        isTabActive:false,
        appLogo:require('./image/app-logo.png'),
        appOnOff:require('./image/app-on-off.png')
      }
    },
    props:{
      tabHoverPage:{
        default:Number
      }
    },
    computed:{
      navTabList(){
        return [
          {id:0, name:'首页'},
          {id:1, name:'产品信息'},
          {id:2, name:'团队介绍'},
          {id:3, name:'合作伙伴'},
          {id:4, name:'关于我们'}
        ]
      }
    },
    methods:{
      actionClickTab(){
        this.isTab = !this.isTab;
      },
      actionClickNavTab(id){
        this.tabHover = id;
        window.scrollTo(0, 0)
        if (id === 0){
          this.$router.push({name:'AppHomePage'});
        } else if (id === 1){
          this.$router.push({name:'AppProductPage'});
        } else if (id === 2){
          this.$router.push({name:'AppTeamPage'});
        } else if (id === 3){
          this.$router.push({name:'AppPartnerPage'});
        } else if (id === 4){
          this.$router.push({name:'AppAboutPage'});
        }
      }
    },
    mounted(){
      this.tabHover = this.tabHoverPage;
    }
  }
</script>
<style lang="scss" rel="stylesheet/scss" scoped="">
  .nav-page-view{
    padding-top:0.88rem;
    .nav-title{
      width:100%;
      height:0.88rem;
      background:$color-4;
      padding:0 0.3rem;
      border-bottom:1px solid #e5e5e5;
      position: fixed;
      top:0;left:0;
      z-index: 100;
      div{
        img{
          width:1.3rem;
        }
        h1{
          font-size:0.3rem;
          color:$color-black;
          padding-left:0.15rem;
        }
      }
      .app-on-off{
        width:0.4rem;
      }
    }
    ul{
      width:100%;
      padding:0 0.3rem;
      background:$color-4;
      position: fixed;
      top:0;left:0;
      z-index:99;
      opacity:0;
      transition: all 0.5s;
      li{
        font-size:0.26rem;
        padding:0.3rem 0;
        color:$color-1;
        border-bottom:2px solid transparent;
      }
      .hover{
        color:#ffd36a;
        border-bottom:2px solid #ffd36a;
      }
    }
    .ulHover{
      top:0.88rem;
      opacity:1;
      transition: all 0.5s;
      z-index: 100;
    }
  }
</style>
